export enum addOnIcon {
  KM = 'km',
  EURO = '€',
  GKM = 'g/km',
  CV = 'CV',
}
